import React, { useRef, useState } from 'react'
import styles from './Phase2.module.css'

import Image from '../../components/Image/Image'
import {
    shuffledArray
} from '../../../../../util/util'

const getWordsButtonIndexes = (currIndex, maxIndex) => {
    const a = [currIndex]
    let n = Math.round(Math.random() * maxIndex)
    while (a.includes(n)) n = Math.round(Math.random() * maxIndex)
    a[1] = n
    n = Math.round(Math.random() * maxIndex)
    while (a.includes(n)) n = Math.round(Math.random() * maxIndex)
    a[2] = n
    n = Math.round(Math.random() * maxIndex)
    while (a.includes(n)) n = Math.round(Math.random() * maxIndex)
    a[3] = n

    return shuffledArray(a)
}

const Button = ({ title, selected, onClick, good }) => {
    return (
        <p
            onClick={onClick}
            className={styles.word}
            style={selected ? { backgroundColor: good ? '#26C281' : '#FF6464', color: 'white' } : {}}>
            {title}
        </p>
    )
}

const Phase2 = ({
    words,
}) => {


    const shuffledPositions = useRef(shuffledArray([...Array(words.length).keys()]))
    const shuffledWordsPositions = useRef(getWordsButtonIndexes(shuffledPositions.current[0], words.length - 1));
    const [currPosition, setCurrPosition] = useState(0)
    const [selectedButton, setSelectedButton] = useState(-1)
    const [isSelectedButtonGood, setIsSelectedButtonGood] = useState(false)
    const [fadeOut, setFadeOut] = useState(false)

    const onButtonClick = (index) => {
        setSelectedButton(index)
        if (shuffledWordsPositions.current[index] === shuffledPositions.current[currPosition]) {
            setIsSelectedButtonGood(true)
            setTimeout(() => {
                setFadeOut(true)
                setSelectedButton(-1)
            }, 500);
            setTimeout(() => {
                setCurrPosition(i => i + 1)
                setFadeOut(false)
            }, 1000)
        }
        else {
            setIsSelectedButtonGood(false)
            setTimeout(() => {
                setSelectedButton(-1)
            }, 500);
        }
    }

    return (
        <div className={styles.container} style={{opacity: fadeOut ? 0 : 1}}>
            <div className={styles.imageContainer}>
                <Image imagePath={words[shuffledPositions.current[currPosition]].img_path} className={styles.image} />
            </div>
            <div className={styles.wordsContainer}>
                {
                    Array(4).fill(null).map((_, index) => {
                        return (
                            <Button
                                title={words[shuffledWordsPositions.current[index]].eng}
                                onClick={() => onButtonClick(index)}
                                selected={selectedButton === index}
                                good={isSelectedButtonGood} />
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Phase2
